import { useWorkspace } from "@sg-protect/shell";
import { Outlet } from "react-router";
import { HomeEntryRedirect } from "../../components/workspace/HomeEntryRedirect.tsx";

export function PartnerWorkspaceGate() {
    const currentWorkspace = useWorkspace();

    if (!currentWorkspace.isPartner) {
        return <HomeEntryRedirect />;
    }

    return <Outlet />;
}
